import Splide from '@splidejs/splide';

export default function () {
	const splideContainer = document.querySelector('.post-carousel-splide');
	if (splideContainer !== null) {
		var splide = new Splide( '.post-carousel-splide', {
			arrows: true,
			pagination: false,
			autoplay: true,
			interval: 5000,
			type: 'loop',
			pauseOnHover: true,
			pauseOnFocus: true,
			autoHeight: true,
		} );
		if (splide === null) {
			return;
		} else {
			splide.mount();
		}
	}
}
